import {ReactComponent as Predict} from 'assets/icons/predict.svg'
import SVG from 'react-inlinesvg';
import classNames from 'classnames';
import styles from './timeline.module.css';
import {getContentPath} from 'system/AssetManager.js';

const EventIcon = ({ id, tagClasses, icon, color, date, onSvgLoad }) => {
    return (
      <span id={`svg_${id}`} className={classNames('eventIcon', tagClasses, styles.eventIcon)}>
        <SVG
          src={getContentPath(icon + '?cb=123')}
          cacheRequests={true}
          width={24}
          height={24}
          preProcessor={(code) =>
            code.replace(/fill=".*?"/g, `fill="${color}"`)
          }
          fetchOptions={{ mode: 'cors', credentials: 'omit' }}
          onLoad={() => onSvgLoad(`svg_${id}`, date)}
          onError={(error) => console.log(error.message)}
        />
      </span>
    );
  };

export default EventIcon;